export default __webpack_public_path__ + "static/media/02.8f484195.jpeg";